import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalObserver } from '../modal-observer';
import { OrderTypeModal } from './order-type-modal';

export const OrderType = ({ name }) => (
  <ModalObserver name={name}>
    {(props) => (
      <ModalWrapper {...props}>
        <OrderTypeModal {...props} />
      </ModalWrapper>
    )}
  </ModalObserver>
);
